import React from 'react';
import PropTypes from 'prop-types';
import {Router, Route} from 'react-router-dom';
import {Security, SecureRoute, ImplicitCallback} from '@okta/okta-react';
import {withRouter} from 'react-router';
import {App, ConnectedApp} from '../containers';

const localGroups = [
  'Anthony Veder Okta - Digital Services / Application Managers',
];

const localToken = `local.${btoa(JSON.stringify({groups: localGroups}))}.local`;

const localAuth = {
  getIdToken: () => Promise.resolve(localToken),
  getUser: () => Promise.resolve({name: 'Local developer'}),
  logout: () => Promise.resolve(),
};

const onAuthRequired = ({auth, history}) => {
  const parsedHash = new URLSearchParams(history.location.hash.substr(1));
  const error = parsedHash.get('error');
  if(error) {
    //eslint-disable-next-line no-alert
    alert(parsedHash.get('error_description') || error);
    auth.logout();
  } else {
    auth.redirect();
  }
};

const AuthRouter = ({history}) =>
  <Router history={history}>
    <Security
      issuer={`https://${process.env.OKTA_DOMAIN}`}
      clientId={process.env.OKTA_CLIENT_ID}
      scopes={['openid', 'profile', 'groups']}
      response_type={['id_token']}
      redirectUri={`${window.location.origin}/implicit/callback`}
      onAuthRequired={onAuthRequired}
    >
      <SecureRoute path="/" component={App} />
      <Route path="/implicit/callback" component={ImplicitCallback} />
    </Security>
  </Router>;

const LocalRouter = ({history}) =>
  <Router history={history}>
    <Route path="/" render={routeProps => <ConnectedApp {...routeProps} auth={localAuth} />} />
  </Router>;

AuthRouter.propTypes = {
  history: PropTypes.object.isRequired,
};

LocalRouter.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(process.env.AUTH_MODE === 'local' ? LocalRouter : AuthRouter);
